const namespaced = true

const state = {
    isPricesConverted: false,
    storedFiltersApplied: false,
    paginator: null,
    numbering: null,
    page: 1,
    totalPropertiesNumber: null,
    selectedPropertyTypes: [],
    selectedDistricts: [],
    selectedBuilders: [],
    selectedComplexes: [],
    selectedBedroomsNumber: null,
    selectedBathroomsNumber: null,
    selectedPersonalId: '',
    selectedIsFinished: null,
    selectedMaxPrice: 30000000,
    selectedMinPrice: 100000,
    selectedHighestPrice: false,
    selectedLowestPrice: true,
    selectedIsNew: false,
    selectedIsPopular: false,
    default: {
        selectedPropertyTypes: [],
        selectedDistricts: [],
        selectedBuilders: [],
        selectedComplexes: [],
        selectedBedroomsNumber: null,
        selectedBathroomsNumber: null,
        selectedPersonalId: '',
        selectedIsFinished: null,
        selectedMaxPrice: 30000000,
        selectedMinPrice: 100000,
        selectedHighestPrice: false,
        selectedLowestPrice: true,
        selectedIsNew: false,
        selectedIsPopular: false,
    }
}

const getters = {
    storedFiltersApplied: (state) => state.storedFiltersApplied,
    paginator: (state) => state.paginator,
    numbering: (state) => state.numbering,
    page: (state) => state.page,
    totalPropertiesNumber: (state) => state.totalPropertiesNumber,
    selectedPropertyTypes: (state) => state.selectedPropertyTypes,
    selectedDistricts: (state) => state.selectedDistricts,
    selectedBuilders: (state) => state.selectedBuilders,
    selectedComplexes: (state) => state.selectedComplexes,
    selectedBedroomsNumber: (state) => state.selectedBedroomsNumber,
    selectedBathroomsNumber: (state) => state.selectedBathroomsNumber,
    selectedPersonalId: (state) => state.selectedPersonalId,
    selectedIsFinished: (state) => state.selectedIsFinished,
    selectedMaxPrice: (state) => state.selectedMaxPrice,
    selectedMinPrice: (state) => state.selectedMinPrice,
    selectedHighestPrice: (state) => state.selectedHighestPrice,
    selectedLowestPrice: (state) => state.selectedLowestPrice,
    selectedIsNew: (state) => state.selectedIsNew,
    selectedIsPopular: (state) => state.selectedIsPopular,
    defaultMaxPrice: (state) => state.default.selectedMaxPrice,
    defaultMinPrice: (state) => state.default.selectedMinPrice,
    isPricesConverted: (state) => state.isPricesConverted,
}

const mutations = {
    setStoredFiltersApplied(state, val) {
        state.storedFiltersApplied = val;
    },
    setPaginator(state, payload) {
        state.paginator = payload;
    },
    setTotalPropertiesNumber(state, payload) {
        state.totalPropertiesNumber = payload;
    },
    setNumbering(state, payload) {
        state.numbering = payload;
    },
    setPage(state, payload) {
        state.page = payload;
    },
    setSelectedPropertyTypes(state, payload) {
        state.selectedPropertyTypes = payload.selectedPropertyTypes;
    },
    setSelectedDistricts(state, payload) {
        state.selectedDistricts = payload.selectedDistricts;
    },
    setSelectedBuilders(state, payload) {
        state.selectedBuilders = payload.selectedBuilders;
    },
    setSelectedComplexes(state, payload) {
        state.selectedComplexes = payload.selectedComplexes;
    },
    setSelectedBedroomsNumber(state, payload) {
        state.selectedBedroomsNumber = payload.selectedBedroomsNumber;
    },
    setSelectedBathroomsNumber(state, payload) {
        state.selectedBathroomsNumber = payload.selectedBathroomsNumber;
    },
    setSelectedPersonalId(state, payload) {
        state.selectedPersonalId = payload.selectedPersonalId;
    },
    setSelectedIsFinished(state, payload) {
        state.selectedIsFinished = payload.selectedIsFinished;
    },
    setSelectedMaxPrice(state, payload) {
        state.selectedMaxPrice = payload.selectedMaxPrice;
    },
    setSelectedMinPrice(state, payload) {
        state.selectedMinPrice = payload.selectedMinPrice;
    },
    setSelectedHighestPrice(state, payload) {
        state.selectedHighestPrice = payload.selectedHighestPrice;
    },
    setSelectedLowestPrice(state, payload) {
        state.selectedLowestPrice = payload.selectedLowestPrice;
    },
    setSelectedIsNew(state, payload) {
        state.selectedIsNew = payload.selectedIsNew;
    },
    setSelectedIsPopular(state, payload) {
        state.selectedIsPopular = payload.selectedIsPopular;
    },
}

const actions = {
    convertSelectedPrices({ commit, state }) {
        if (!state.isPricesConverted)
        {
            axios.get('/api/v1/currencies/convert', {
                params: {
                    filtrationBaseMaxPrice: state.default.selectedMaxPrice,
                    filtrationBaseMinPrice: state.default.selectedMinPrice,
                    currency : window.currentCurrency
                }
            }).then(response => {
                // округлим цены для фильтрации
                let magnitude = Math.pow(10, Math.floor(Math.log10(response.data.maxPrice)));
                response.data.maxPrice = Math.ceil(response.data.maxPrice / magnitude) * magnitude;

                magnitude = Math.pow(10, Math.floor(Math.log10(response.data.minPrice)));
                response.data.minPrice = Math.floor(response.data.minPrice / magnitude) * magnitude;

                state.default.selectedMaxPrice = response.data.maxPrice;
                state.default.selectedMinPrice = response.data.minPrice;
                state.selectedMaxPrice = state.default.selectedMaxPrice;
                state.selectedMinPrice = state.default.selectedMinPrice;
                state.isPricesConverted = true;
            }).catch(error => {
                console.error('Filtration error: ', error);
            });
        }
    },
    resetFiltrationParams({ state, dispatch }){
        dispatch('updateSelectedFilters', state.default);
    },
    extractFromLocalStorageToState({ state, dispatch }){
        let queryParams = window.localStorage.getItem('filtration');
        if (!!queryParams && queryParams !== 'null') {
            queryParams = JSON.parse(queryParams);
            dispatch('updateSelectedFilters', queryParams);
            state.default = queryParams.default;
            state.isPricesConverted = queryParams.isPricesConverted;
        }
    },
    saveToLocalStorage({ state }){
        const queryParamsLocalStorage = {
            isPricesConverted: state.isPricesConverted,
            selectedPropertyTypes: state.selectedPropertyTypes,
            selectedDistricts: state.selectedDistricts,
            selectedBuilders: state.selectedBuilders,
            selectedComplexes: state.selectedComplexes,
            selectedBedroomsNumber: state.selectedBedroomsNumber,
            selectedBathroomsNumber: state.selectedBathroomsNumber,
            selectedPersonalId: state.selectedPersonalId,
            selectedIsFinished: state.selectedIsFinished,
            selectedMaxPrice: state.selectedMaxPrice,
            selectedMinPrice: state.selectedMinPrice,
            selectedHighestPrice: state.selectedHighestPrice,
            selectedLowestPrice: state.selectedLowestPrice,
            selectedIsNew: state.selectedIsNew,
            selectedIsPopular: state.selectedIsPopular,
            default: state.default
        }
        window.localStorage.setItem('filtration', JSON.stringify(queryParamsLocalStorage));
    },
    redirectToPropertiesPage({ state, dispatch }) {
        const queryParamsURL = {
            propertyTypesIds: JSON.stringify(state.selectedPropertyTypes.map(type => type.id)),
            districtsIds: JSON.stringify(state.selectedDistricts.map(type => type.id)),
            buildersIds: JSON.stringify(state.selectedBuilders.map(type => type.id)),
            complexesIds: JSON.stringify(state.selectedComplexes.map(type => type.id)),
            bedroomsNumber: state.selectedBedroomsNumber,
            bathroomsNumber: state.selectedBathroomsNumber,
            personalId: state.selectedPersonalId,
            isFinished: state.selectedIsFinished,
            maxPrice: state.selectedMaxPrice,
            minPrice: state.selectedMinPrice,
            highestPrice: state.selectedHighestPrice,
            lowestPrice: state.selectedLowestPrice,
            isNew: state.selectedIsNew,
            isPopular: state.selectedIsPopular
        }

        dispatch('saveToLocalStorage');

        let locale = '';
        if (document.documentElement.lang !== 'ru') locale = '/' + document.documentElement.lang;

        window.location.href = locale + '/properties-for-sale/?' + new URLSearchParams(queryParamsURL).toString();
    },
    updateSelectedPropertyTypes({ commit, dispatch }, params) {
        commit('setSelectedPropertyTypes', params);
    },
    updateSelectedFilters({ commit, dispatch }, params) {
        commit('setSelectedPropertyTypes', params);
        commit('setSelectedDistricts', params);
        commit('setSelectedBuilders', params);
        commit('setSelectedComplexes', params);
        commit('setSelectedBedroomsNumber', params);
        commit('setSelectedBathroomsNumber', params);
        commit('setSelectedPersonalId', params);
        commit('setSelectedIsFinished', params);
        commit('setSelectedMaxPrice', params);
        commit('setSelectedMinPrice', params);
        commit('setSelectedHighestPrice', params);
        commit('setSelectedLowestPrice', params);
        commit('setSelectedIsNew', params);
        commit('setSelectedIsPopular', params);
    },
    setSelectedMinPrice({ commit }, payload) {
        commit('setSelectedMinPrice', payload)
    },
    setSelectedMaxPrice({ commit }, payload) {
        commit('setSelectedMaxPrice', payload)
    },
    setSelectedPropertyTypes({ commit }, payload) {
        commit('setSelectedPropertyTypes', payload)
    },
    setSelectedDistricts({ commit }, payload) {
        commit('setSelectedDistricts', payload)
    },
    setSelectedIsNew({ commit }, payload) {
        commit('setSelectedIsNew', payload)
    },
    setSelectedIsPopular({ commit }, payload) {
        commit('setSelectedIsPopular', payload)
    },
    setSelectedLowestPrice({ commit }, payload) {
        commit('setSelectedLowestPrice', payload)
    },
    setSelectedHighestPrice({ commit }, payload) {
        commit('setSelectedHighestPrice', payload)
    },
    setSelectedBuilders({ commit }, payload) {
        commit('setSelectedBuilders', payload)
    },
    setSelectedComplexes({ commit }, payload) {
        commit('setSelectedComplexes', payload)
    },
    setSelectedBedroomsNumber({ commit }, payload) {
        commit('setSelectedBedroomsNumber', payload)
    },
    setSelectedBathroomsNumber({ commit }, payload) {
        commit('setSelectedBathroomsNumber', payload)
    },
    setSelectedPersonalId({ commit }, payload) {
        commit('setSelectedPersonalId', payload)
    },
    setSelectedIsFinished({ commit }, payload) {
        commit('setSelectedIsFinished', payload)
    },
}

export default {
    mutations,
    actions,
    state,
    getters,
    namespaced,
}
